module.exports = __webpack_public_path__ + "img/edit.714e038b.svg";